module.exports = __webpack_public_path__ + "img/repayment-amount-total.927dfcd6.svg";